import classNames from 'classnames';
import { forwardRef } from 'react';
import { useNeedsUpgrade } from './use_needs_upgrade';
const containerCss = "c1fihx64";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const inert = 'inert';
  const className = 'disabled-area';
  return <Component ref={ref} {...restProps} inert={inert} className={classNames(containerCss, className)} />;
});
export const Overlay = ({
  children
}) => {
  const needsUpgrade = useNeedsUpgrade();
  if (!needsUpgrade) return children;
  return <Container>{children}</Container>;
};

require("./overlay.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./overlay.js");